import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Button } from "@platform/design-system";

interface ConfirmationHiddenColumnsDialogProps {
  open: boolean;
  coverageLabels: string[];
  onCancel: () => void;
  onConfirm: () => void;
}

export function ConfirmationHiddenColumnsDialog({
  open,
  coverageLabels,
  onCancel,
  onConfirm,
}: ConfirmationHiddenColumnsDialogProps): React.JSX.Element {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="hidden-columns-dialog-title"
      aria-describedby="hidden-columns-dialog-description"
    >
      <DialogTitle id="hidden-columns-dialog-title">
        Submit with hidden columns?
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="hidden-columns-dialog-description">
          This RFP is being sent with hidden columns in{" "}
          <strong>{coverageLabels.join(", ")}</strong>. Click cancel to go back
          and review these coverages, or proceed with RFP Submission.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="tertiary">
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
